import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME } from '../reducer';
import { I18n } from 'react-redux-i18n';
import PopupWarning from './../../../common/popup-portal/popup-warning/PopupWarning';

class PopupWarningNoTicker extends React.Component {
  render() {
    const {
      parentRef,
      currentTab,
      listTickerRanking,
      currentItemSearch,
      isLoading,
    } = this.props;
    let isShowPopup = false;

    if (!isLoading) {
      if (
        currentTab === 1 &&
        !listTickerRanking.length &&
        Object.keys(currentItemSearch).length
      ) {
        isShowPopup = true;
      }
    }

    if (!isShowPopup) return null;
    return (
      <PopupWarning
        text={I18n.t('stRanking.popup.warning.title')}
        isShow={isShowPopup}
        onOverlayClicked={true}
        textContent={I18n.t('stRanking.popup.warning.content')}
        parentRef={parentRef ? parentRef.current : null}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    listTickerAllScore: state[REDUCER_NAME].listTickerAllScore,
    listTickerRanking: state[REDUCER_NAME].listTickerRanking,
    currentTab: state[REDUCER_NAME].currentTab,
    isLoading: state[REDUCER_NAME].isLoading,
    currentItemSearch: state[REDUCER_NAME].currentItemSearch,
  };
};

export default connect(mapStateToProps)(PopupWarningNoTicker);
